import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import "./../summeryTableStyle.css"

const AdminJillaSummary = () => {

  const [gurudakshinas, setGurudakshinas] = useState([]);

  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinaPerPage = 50;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [pranthList, setPranthList] = useState([]);

  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [selectedVibhagId, setSelectedVibhagId] = useState("");
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedJillaId, setSelectedJillaId] = useState("");
  const [jillaList, setJillaList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");
          setJillaList([]);
          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);

  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };

  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
      if (data.length > 0) {
        setSelectedJillaId(data[0].jilla_id); // default selection
      } else {
        setSelectedJillaId("");
      }
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);

  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);



  const fetchArppanSummary = useCallback(async () => {
    if (!selectedJillaId) return;  // 🛑 Prevent API call if undefined or empty
    setLoading(true);
    setError(null);
    setHasSearched(true);
    try {
      const url = `get-jilla-arppan-summary?jilla_id=${selectedJillaId}`;
      const response = await axiosPrivate.get(url, { withCredentials: true });
      setLoading(false);
      if (response.status === 204) {
        // ✅ No Content case
        setGurudakshinas([]);
        setLoading(false);
        setError("No Data available.");
        return;
      }

      // ✅ Handle valid data
      // setGurudakshinas(Array.isArray(response.data) ? response.data : []);
      setGurudakshinas(response.data);


    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setGurudakshinas([]); // Clear old data in case of error
      setLoading(false);
    }
  }, [axiosPrivate, selectedJillaId]);


  const summaryData = gurudakshinas?.data || [];

  const vs = summaryData.find(item => item.sakha === "Vidyarthi Samyuktha");
  const vt = summaryData.find(item => item.sakha === "Vidyarthi Tharuna");
  const vy = summaryData.find(item => item.sakha === "Vyavasayi Tharuna");
  const pr = summaryData.find(item => item.sakha === "Prouda");

  useEffect(() => {
    fetchArppanSummary();
  }, [selectedJillaId]);





  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  return (
    <>
      <style>{`
  #customers th, #customers td {

    min-width: 144px;
  }`}</style>

      <section className="empbody">
        <div className="wrapperemp2">
          {/* ✅ Finalize Button with Modal trigger */}

          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

          <div
          // className="d-flex justify-content-end align-items-center gap-2 mb-3"
          >
          </div>

          <h3>Jilla Summary</h3>

          <Row>
            {/* <Col md={3}>
              <Form.Label className="newformstyle">Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => {
                  const pranthId = e.target.value;
                  setSelectedPranthId(pranthId);

                  if (!pranthId) {
                    // Clear vibhag, jilla, and table if no Pranth selected
                    setVibhagList([]);
                    setSelectedVibhagId("");
                    setJillaList([]);
                    setSelectedJillaId("");
                  }
                }}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>

            </Col> */}

            <Col md={6}>
              <Form.Label className="newformstyle">Vibhag</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedVibhagId}
                onChange={(e) => {
                  const vibhagId = e.target.value;
                  setSelectedVibhagId(vibhagId);

                  if (!vibhagId) {
                    // Clear Jilla list and selection if no Vibhag selected
                    setJillaList([]);
                    setSelectedJillaId("");
                  }
                }}
                disabled={!vibhagList.length}
              >
                <option value="">-- Select Vibhag --</option>
                {Array.isArray(vibhagList) &&
                  vibhagList.map((v) => (
                    <option key={v.vibhag_id} value={v.vibhag_id}>
                      {v.vibhag_name}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label className="newformstyle">Jilla</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedJillaId}
                onChange={(e) => {
                  const jillaId = e.target.value;
                  setSelectedJillaId(jillaId); // ✅ Just update state

                }}
                disabled={!jillaList.length}
              >
                <option value="">-- Select Jilla --</option>
                {jillaList.map((j) => (
                  <option key={j.jilla_id} value={j.jilla_id}>
                    {j.jilla_name}
                  </option>
                ))}
              </Form.Select>

            </Col>
          </Row>

          <div className="table-container">
            {hasSearched && (
              <div className="table-container">
                {hasSearched && (
                  <table id="customers" className="table table-bordered text-center summary-table">
                    <thead>
                      <tr>
                        <th colSpan={1} className="text-center">
                          SHRENI
                        </th>
                        <th colSpan={5} className="text-center">
                          UPASTHITHI/THUKA
                        </th>
                      </tr>
                      <tr>
                        <th rowSpan={2}></th>
                        <th>VIDHYARTHI SAMYUKTHA</th>
                        <th>VIDHYARTHI THARUNA</th>
                        <th>VYAVASAYI THARUNA</th>
                        <th>PROUDA</th>
                        <th>TOTAL</th>
                      </tr>
                      <tr>
                        <th>({gurudakshinas?.vs_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.vt_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.vy_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.pr_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.uthsavam ?? 0})</th>
                      </tr>
                    </thead>

                    <tbody><tr>
                      <th>SISU</th>

                      <td>
                        <div>{vs?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vs?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>
                      </td>

                      <td>
                        <div> {vt?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vt?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>



                      </td>

                      <td>

                        <div> {vy?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vy?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>


                      </td>

                      <td>
                        <div> {pr?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(pr?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>



                      </td>

                      <td>
                        {(vs?.sisu ?? 0) +
                          (vt?.sisu ?? 0) +
                          (vy?.sisu ?? 0) +
                          (pr?.sisu ?? 0)}
                        <br />
                        ₹
                        {(
                          Number(vs?.sisuAmount ?? 0) +
                          Number(vt?.sisuAmount ?? 0) +
                          Number(vy?.sisuAmount ?? 0) +
                          Number(pr?.sisuAmount ?? 0)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                      <tr>
                        <th>BALA</th>

                        <td>
                          {vs?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.bala ?? 0) +
                            (vt?.bala ?? 0) +
                            (vy?.bala ?? 0) +
                            (pr?.bala ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.balaAmount ?? 0) +
                            Number(vt?.balaAmount ?? 0) +
                            Number(vy?.balaAmount ?? 0) +
                            Number(pr?.balaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>

                      <tr>
                        <th>VIDHYARTHI THARUNA</th>

                        <td>
                          {vs?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.vtharuna ?? 0) +
                            (vt?.vtharuna ?? 0) +
                            (vy?.vtharuna ?? 0) +
                            (pr?.vtharuna ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.vtharunaAmount ?? 0) +
                            Number(vt?.vtharunaAmount ?? 0) +
                            Number(vy?.vtharunaAmount ?? 0) +
                            Number(pr?.vtharunaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>

                      <tr>
                        <th>VYAVASAYI THARUNA</th>

                        <td>
                          {vs?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.tharuna ?? 0) +
                            (vt?.tharuna ?? 0) +
                            (vy?.tharuna ?? 0) +
                            (pr?.tharuna ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.tharunaAmount ?? 0) +
                            Number(vt?.tharunaAmount ?? 0) +
                            Number(vy?.tharunaAmount ?? 0) +
                            Number(pr?.tharunaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                      <tr>
                        <th>PROUDA</th>

                        <td>
                          {vs?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.prouda ?? 0) +
                            (vt?.prouda ?? 0) +
                            (vy?.prouda ?? 0) +
                            (pr?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.proudaAmount ?? 0) +
                            Number(vt?.proudaAmount ?? 0) +
                            Number(vy?.proudaAmount ?? 0) +
                            Number(pr?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                      <tr>
                        <th>TOTAL</th>

                        <td>
                          {(vs?.sisu ?? 0) +
                            (vs?.bala ?? 0) +
                            (vs?.vtharuna ?? 0) +
                            (vs?.tharuna ?? 0) +
                            (vs?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.sisuAmount ?? 0) +
                            Number(vs?.balaAmount ?? 0) +
                            Number(vs?.vtharunaAmount ?? 0) +
                            Number(vs?.tharunaAmount ?? 0) +
                            Number(vs?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vt?.sisu ?? 0) +
                            (vt?.bala ?? 0) +
                            (vt?.vtharuna ?? 0) +
                            (vt?.tharuna ?? 0) +
                            (vt?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vt?.sisuAmount ?? 0) +
                            Number(vt?.balaAmount ?? 0) +
                            Number(vt?.vtharunaAmount ?? 0) +
                            Number(vt?.tharunaAmount ?? 0) +
                            Number(vt?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vy?.sisu ?? 0) +
                            (vy?.bala ?? 0) +
                            (vy?.vtharuna ?? 0) +
                            (vy?.tharuna ?? 0) +
                            (vy?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vy?.sisuAmount ?? 0) +
                            Number(vy?.balaAmount ?? 0) +
                            Number(vy?.vtharunaAmount ?? 0) +
                            Number(vy?.tharunaAmount ?? 0) +
                            Number(vy?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(pr?.sisu ?? 0) +
                            (pr?.bala ?? 0) +
                            (pr?.vtharuna ?? 0) +
                            (pr?.tharuna ?? 0) +
                            (pr?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(pr?.sisuAmount ?? 0) +
                            Number(pr?.balaAmount ?? 0) +
                            Number(pr?.vtharunaAmount ?? 0) +
                            Number(pr?.tharunaAmount ?? 0) +
                            Number(pr?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vs?.totalUpasthith ?? 0) +
                            (vt?.totalUpasthith ?? 0) +
                            (vy?.totalUpasthith ?? 0) +
                            (pr?.totalUpasthith ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.totalAmount ?? 0) +
                            Number(vt?.totalAmount ?? 0) +
                            Number(vy?.totalAmount ?? 0) +
                            Number(pr?.totalAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        </div >
      </section >

      <TopBar />
    </>
  );
};

export default AdminJillaSummary;
